<template>
  <div module-item :class="info.type">
    <h5>Credits</h5>
    <div v-if="info.value.text" v-html="info.value.text"></div>
  </div>
</template>

<script>

export default {
  name: 'Credit',
  props: ['value'],
  computed: {
    info() {
      return this.value;
    },
  },
}
</script>

